import React from 'react';
import NewResetPassword from '../../@jumbo/components/Common/authComponents/NewResetPassword';

const NewSetPasswordPage = () => <NewResetPassword variant="standard" wrapperVariant="bgColor" />;

export default NewSetPasswordPage;
